module.exports = __webpack_public_path__ + "img/side-banner_2.40f586cf.jpg";